import { IGetTrxData, IGetTrxHistoryData } from "../../../../services/trxService";
import { UploadMediaI } from "../../../../typings/common";
import { ISubmissionPost } from "../SubmissionForm/types";

export const generateFileList = (uploadedMedia: UploadMediaI[], data: ISubmissionPost) => (
  uploadedMedia.map((file, i) => ({
    item_id: i,
    file_name: file.FileName,
    file_base64: file.FileUrl,
    file_size: file.FileSize,
    create_by: data.employeeName,
  }))
);

interface ExtendSubmissionPostI extends ISubmissionPost {
  email: string,
  fileList: ReturnType<typeof generateFileList>
}

export const generatePostTrxPayload = (data: ExtendSubmissionPostI) => ({
  trx_type: data.trxType.value as string,
  code_type: data.codeType.value as string,
  area_id: data.area.value as string,
  pool_id: data.pool.value as string,
  company_code: data.company.value as string,
  company_relations: data.companyRelation ? data.companyRelation.value as string : "",
  code_segment: data.segment.value as string,
  department: data.department,
  trx_date: new Date().toISOString(),
  plan_postdate: data.planPostDate,
  trx_code: data.trxCode || "",
  trx_text: data.description,
  amount: data.amount,
  prctr: "",
  kostl: "",
  kunnr: "",
  lifnr: "",
  approval_code: "",
  idtrx1: "",
  idtrx2: "",
  idtrx3: "",
  beneficiary_code: (!(data.trxType.value === "BKI" || data.trxType.value === "BKS") && data.beneficiaryCode) || "",
  source_code: "",
  employee_id: data.employeeNip,
  employee_name: data.employeeName,
  employee_email: data.email,
  job_id: data.jobId,
  job_title: data.jobTitle,
  item_bon_merah: {
    trx_bm_type: data.redReceiptType?.label || "",
  },
  item_bon_putih_ijir: {
    trx_id_bon_merah: data.redReceiptNumber || "",
  },
  create_by: data.employeeName,
  lsttrxfile: data.fileList,
});

export const isIGetTrxHistoryData = (
  item: IGetTrxData | IGetTrxHistoryData,
): item is IGetTrxHistoryData => (
  !!(item as IGetTrxHistoryData).code_segment
);
